import type { PopoverProps } from '@shopify/polaris';

import { Popover, Scrollable } from '@shopify/polaris';

export interface GPopoverProps extends PopoverProps {
  /**
   * The maximum width of the popover content.
   * This is only used if `fluidContent` is `true`.
   * @default 25rem;
   */
  maxWidth?: `${number}px` | `${number}rem`;
  /**
   * The max height of the popover content.
   * This is only used if `fluidContent` is `true`.
   * @default 31.25rem;
   */
  maxHeight?: `${number}px` | `${number}rem`;
  /**
   * Whether to enable vertical scrolling.
   * @default true;
   */
  vertical?: boolean;
  /**
   * Whether to enable horizontal scrolling.
   * @default true;
   */
  horizontal?: boolean;
}

export const GPopover = (props: GPopoverProps) => {
  const {
    maxWidth,
    maxHeight,
    children,
    vertical = true,
    horizontal = false,
    ...popoverProps
  } = props;

  const isCustomFluidContent = props.fluidContent && (!!maxHeight || !!maxWidth);
  if (!isCustomFluidContent) return <Popover {...popoverProps}>{children}</Popover>;

  return (
    <Popover fluidContent={false} {...popoverProps}>
      <div
        className="Polaris-GPopover-Content"
        style={
          {
            '--gx-pc-popover-max-width': maxWidth ?? '25rem',
            '--gx-pc-popover-max-height': maxHeight ?? '31.25rem',
          } as React.CSSProperties
        }
      >
        <Scrollable
          style={{ maxHeight: `100%` }}
          vertical={vertical}
          horizontal={horizontal}
          scrollbarWidth="thin"
        >
          {children}
        </Scrollable>
      </div>
    </Popover>
  );
};
